import { defineStore } from 'pinia'

const state = () => ({
  show: false,
  allFilesUploadDone: null,
  fileUploadDone: null,
  remoteFileUploadRequest: null,
  previousItemSelectedIndex: null,
})

// functionName: (state, getters, rootState) => {}
const getters = {
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  openModal(allFilesUploadDone, fileUploadDone, remoteFileUploadRequest) {
    this.allFilesUploadDone = allFilesUploadDone
    this.fileUploadDone = fileUploadDone
    this.remoteFileUploadRequest = remoteFileUploadRequest

    this.show = true
  },
  closeModal() {
    this.allFilesUploadDone = null
    this.fileUploadDone = null
    this.remoteFileUploadRequest = null
    this.previousItemSelectedIndex = null

    this.show = false
  },
}

export default defineStore({
  id: 'bcStorageExplorer',
  state,
  getters,
  actions
})
